export { default as UiFooterNavBasic } from "./UiFooterNavBasic";
